const BetsModule = () => import(/* webpackChunkName: "bets-module" */ './views/Module.vue');
const Bets = () => import(/* webpackChunkName: "bets" */ './views/Bets.vue');
const Statements = () => import(/* webpackChunkName: "statements" */ './views/Statements.vue');
const StatementDetails = () => import(/* webpackChunkName: "statement-detail" */ './views/StatementDetail.vue');
const ProfitLoss = () => import(/* webpackChunkName: "profit-loss" */ './views/ProfitLoss.vue');
const ProfitLossDetails = () => import(/* webpackdhunkname: "profit-loss-detail" */ './views/ProfitLossDetail.vue');
const MatchMarket = () => import(/* webpackChunkName: "match-market" */ './views/MatchMarket.vue');
const CompletedEvents = () => import(/* webpackChunkName: "completed-events" */ './views/CompletedEvents.vue');

const BetsRoutes =   {
    path: '/',
    component: BetsModule,
    children: [
        {
            path: 'bets/:type',
            name: 'bets',
            component: Bets,
            meta: {
                title: 'Open Bets'
            }
        },
        {
            path: 'completed-events',
            name: 'completed-events',
            component: CompletedEvents,
            meta: {
                title: 'Completed Events'
            }
        },
        {
            path: 'match-market',
            name: 'match-market',
            component: MatchMarket,
            meta: {
                title: 'Open Bets Details'
            }
        },
        {
            path: 'statements',
            name: 'statements',
            component: Statements,
            meta: {
                title: 'Account Statement'
            }
        },
        {
            path: 'statement-detail',
            name: 'statement-detail',
            component: StatementDetails,
            meta: {
                title: 'Account Statement Details'
            }
        },
        {
            path: 'profit-loss',
            name: 'profit-loss',
            component: ProfitLoss,
            meta: {
                title : 'Betting Profit Loss'
            }
        },
        {
            path: 'profit-loss-detail',
            name: 'profit-loss-detail',
            component: ProfitLossDetails,
            meta: {
                title: 'Betting Profit Loss Details'
            }
        }
    ],
}

export default BetsRoutes;